import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Brand from '../components/Brand'
import PersonalStep from '../components/onboarding/PersonalStep'
import AcademicStep from '../components/onboarding/AcademicStep'
import ProfessionalStep from '../components/onboarding/ProfessionalStep'
import './OnboardingPage.css'

const steps = ['Personal', 'Academic', 'Professional']

function OnboardingPage() {
  const { user } = useAuth()

  if (!user) {
    return null
  }

  if (user.profileLevel >= 3) {
    return <Navigate to="/code" replace />
  }

  const level = user.profileLevel || 0

  return (
    <div className="onb">
      <header className="onb-header">
        <Brand />
      </header>
      <div className="onb-card">
        <div className="onb-progress">
          {steps.map((label, index) => (
            <div
              key={label}
              className={`onb-pill ${index === level ? 'active' : ''} ${index < level ? 'done' : ''}`}
            >
              <span className="onb-pill-num">{index + 1}</span>
              <span className="onb-pill-label">{label}</span>
            </div>
          ))}
        </div>

        {level === 0 && <PersonalStep />}
        {level === 1 && <AcademicStep />}
        {level === 2 && <ProfessionalStep />}
      </div>
    </div>
  )
}

export default OnboardingPage
